import React, { useEffect, useState } from 'react';
import PlanningDetailSnapshotService from '../../../Services/PlanningDetailSnapshotService.js';
import PlanningDetailSnapshotItem from '../../../Domain/PlanningDetailSnapshotItem.js';
import dateTimeHelper from '../../../Helpers/datetimeHelper.js';

const FIELDS = [
  { name: 'NumberOfPlannedAssignments', label: 'Volume' },
  { name: 'StartDate', label: 'Start Date', format: 'date' },
  { name: 'EndDate', label: 'End Date', format: 'date' },
  { name: 'Status', label: 'Status' },
  { name: 'SnapshotDateUtc', label: 'Snapshot Date (UTC)', format: 'date' },
];

function renderValue(value, format) {
  if (value === null || value === undefined || value === '') return '';
  if (format === 'date') return dateTimeHelper.toYYYYsMMsDD(value);
  return String(value);
}

function PlanningDetailSnapshotInlineSummary({ planningDetailId }) {
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!planningDetailId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    PlanningDetailSnapshotService.GetByPlanningDetailId(planningDetailId, 1)
      .then((response) => {
        const list = Array.isArray(response) ? response : [];
        setSnapshot(list.length > 0 ? new PlanningDetailSnapshotItem(list[0]) : null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [planningDetailId]);

  if (loading) return <div className='m-2 text-muted'>Loading snapshot...</div>;
  if (!snapshot) return <div className='m-2 text-muted'>No snapshot yet for this Planning Detail.</div>;

  // Mirrors TabListTableFigma's design-system detail layout (def-cols → def-card → def-row)
  // so this tab matches the other field-driven tabs of the detail panel.
  return (
    <div className='def-cols'>
      <div className='def-card'>
        {FIELDS.map((field) => {
          const value = renderValue(snapshot[field.name], field.format);
          return (
            <div
              className='def-row'
              key={field.name}
            >
              <div className='k'>{field.label}</div>
              <div className={`v${value === '' ? ' muted' : ''}`}>{value}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default PlanningDetailSnapshotInlineSummary;
